import { render, staticRenderFns } from "./ReceivableDetail.vue?vue&type=template&id=306d7f97&"
import script from "./ReceivableDetail.vue?vue&type=script&lang=js&"
export * from "./ReceivableDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports